G.WorldMapSocialLayer = function(map) {

    Phaser.Group.call(this, game);
    this.state = game.state.getCurrentState();

    this.position = map.position;
    this._initialized = false;

    this.avatarEntries = [];

    map.signals.onMapScrolled.add(G.Helpers.callOnThreshold(100, this._checkInstancesPlacements, this));

    this._initLabels();
};

G.WorldMapSocialLayer.prototype = Object.create(Phaser.Group.prototype);


G.WorldMapSocialLayer.prototype._initLabels = async function() {
    console.log("sociallayer");
    let userList = await OMT.friends.getFriendsList();
    var usedLvls = [];

    var maxLevelIndex = G.Helpers.levelDataMgr.getMaxLevelIndex();

    for (var i = 0; i < userList.length; i++) {
        var user = userList[i];
        if (user.id == OMT.envData.settings.user.userId || user.maxLevel === undefined || !user.image) continue;

        var levelIndex = game.math.clamp(user.maxLevel - 1, 0, maxLevelIndex);
        var lvlData = G.Helpers.levelDataMgr.getLevelByIndex(levelIndex);;
        if (!lvlData) continue;

        var entry = this._getEntryForLevelIndex(levelIndex);
        if (entry.avatars.length >= 3) continue;

        entry.avatars.push(user.image);

    }
    this._initialized = true;
    this._checkInstancesPlacements();
};

G.WorldMapSocialLayer.prototype._getEntryForLevelIndex = function(levelIndex) {
    var existingEntry = this.avatarEntries.find(function(entry) {
        return entry.levelIndex === levelIndex;
    });

    if (existingEntry) return existingEntry;

    var newEntry = {
        levelIndex: levelIndex,
        avatars: [],
        instances: [],
        mapPosition: G.Helpers.levelDataMgr.getMapPositionOfLevelIndex(levelIndex),
    };
    this.avatarEntries.push(newEntry);

    return newEntry;
};

G.WorldMapSocialLayer.prototype._checkInstancesPlacements = function() {
    this.avatarEntries.forEach(function(entry) {
        var screenY = this.y + entry.mapPosition.y;
        var inScreen = screenY > -200 && screenY < game.height + 200;
        if (inScreen && entry.instances.length == 0) {
            this._createAvatarInstances(entry);
        } else if (!inScreen && entry.instances.length > 0) {
            this._removeAvatarInstances(entry);
        }
    }, this);
};

G.WorldMapSocialLayer.prototype._createAvatarInstances = function(entry) {
    entry.avatars.forEach(function(avatarUrl, index) {
        var mapX = entry.mapPosition.x;
        var mapY = entry.mapPosition.y;
        var avatar = new G.WorldMapSocialLayer.MapLabel(mapX, mapY, avatarUrl, index * 30);
        this.add(avatar);
        entry.instances.push(avatar);
    }, this);
};

G.WorldMapSocialLayer.prototype._removeAvatarInstances = function(entry) {
    entry.instances.forEach(function(instance) {
        instance.destroy();
    });
    entry.instances = [];
};

G.WorldMapSocialLayer.prototype.update = function() {

};

G.WorldMapSocialLayer.MapLabel = function(x, y, imgUrl, extraOffset) {

    extraOffset = extraOffset || 0;

    Phaser.Group.call(this, game);
    this.position.setTo(x + 50 + extraOffset, y - 20);

    this.scale.setTo(0);
    var that = this;
    this.avatar = G.makeExtImage(0, 0, imgUrl, null, 0.5, this, false, function() {
        this.width = 50;
        this.height = 50;
        game.add.tween(that.scale).to({
            x: 1,
            y: 1
        }, 500, Phaser.Easing.Elastic.Out, true);
    });

    this.border = G.makeImage(0, 0, 'avatar_frame', 0.5, this);

};

G.WorldMapSocialLayer.MapLabel.prototype = Object.create(Phaser.Group.prototype);